import {AutoPan} from './AutoPan';
import {EdgeNav} from './EdgeNav';
import app from '../../public-api';

app.plugins.register({
  name: 'us:auto-pan',

  extends: 'viewport',

  constructor (uScope, viewport) {
    const autoPan = new AutoPan(uScope, viewport);
    const en = new EdgeNav(uScope, viewport, autoPan);

    autoPan.init();
    en.init();
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/auto-pan/auto-pan-loader.js